import { CalendarEntry } from "Components/Calendar/CalendarEntryHelper";
import moment, { Moment } from "moment";
import { CellSize } from "Components/Calendar/CalendarHelper";
import { ResizePixelSet } from "Components/Resize/ResizeHelper";
import { DropArea } from "Components/DropArea/types/DropArea";

export function getDayCalendarEntries(
	calendarEntries: CalendarEntry[],
	startOfDay: Moment
) {
	const endOfDay = startOfDay.clone().add(1, "day");

	return calendarEntries.filter((scheduleEntry) => {
		const startTime = moment.unix(scheduleEntry.startTime);
		const endTime = moment.unix(scheduleEntry.endTime);
		return startTime.isBefore(endOfDay) && endTime.isAfter(startOfDay);
	});
}

// This function checks if a calendar entry overlaps with a given hour column
// It should be used for displaying entries that extend across multiple hours
export function isDayCalendarEntryOverlappingColumn(
	startOfHour: moment.Moment,
	calendarEntry: CalendarEntry
) {
	const endOfHour = startOfHour.clone().add(1, "hour");
	const startTime = moment.unix(calendarEntry.startTime);
	const endTime = moment.unix(calendarEntry.endTime);

	// Entry starts in this column
	if (startTime.isSameOrAfter(startOfHour) && startTime.isBefore(endOfHour)) {
		return true;
	}

	// Entry ends in this column
	if (endTime.isAfter(startOfHour) && endTime.isSameOrBefore(endOfHour)) {
		return true;
	}

	// Entry spans across this column
	return startTime.isBefore(startOfHour) && endTime.isAfter(endOfHour);


}

export function isDayCalendarEntryStartingOrEndingInsideColumn(
	startOfHour: moment.Moment,
	calendarEntry: CalendarEntry
) {
	const endOfHour = startOfHour.clone().add(1, "hour");
	const startTime = moment.unix(calendarEntry.startTime);
	const endTime = moment.unix(calendarEntry.endTime);

	// Check if entry starts or ends in this column
	return (startTime.isSameOrAfter(startOfHour) && startTime.isBefore(endOfHour)) ||
	       (endTime.isSameOrAfter(startOfHour) && endTime.isBefore(endOfHour));
}

export function isDayDropAreaStartingInsideColumn(
	startOfHour: moment.Moment,
	dropArea: DropArea
) {
	const dropAreaHour = dropArea.start.hours();
	const columnHour = startOfHour.hours();

	return dropAreaHour === columnHour;
}

export function isDropAreaOverlappingHour(
	startOfHour: moment.Moment,
	dropArea: DropArea
) {
	const endOfHour = startOfHour.clone().add(1, 'hour');
	return dropArea.start.isBefore(endOfHour) && dropArea.end.isAfter(startOfHour);
}

export function getIsDaySingleRow(calendarEntries: CalendarEntry[]) {
	const sortedEntries = [...calendarEntries].sort(
		(a, b) => a.startTime - b.startTime
	);

	for (let i = 0; i < sortedEntries.length - 1; i++) {
		if (sortedEntries[i].endTime > sortedEntries[i + 1].startTime) {
			return false;
		}
	}

	return true;
}

export function getDaySchedulePhasesResizePixelSet(
	startOfDay: Moment,
	cellSize: CellSize
) {
	const offsetPixel = cellSize.day.nameWidth + cellSize.offset.left;
	const resizePixelSet: ResizePixelSet = {
		left: [],
		right: [],
	};

	for (let hour = 0; hour <= 23; hour++) {
		const dateTime = startOfDay.clone().add(hour, "hours");

		resizePixelSet.left.push({
			pixel: offsetPixel + cellSize.day.hourWidth * hour,
			dateTime: dateTime.clone(),
		});

		resizePixelSet.right.push({
			pixel: offsetPixel + cellSize.day.hourWidth * (hour + 1) - 1,
			dateTime: dateTime.clone(),
		});
	}

	return resizePixelSet;
}
